import { render, staticRenderFns } from "./grid.vue?vue&type=template&id=20987b80&"
import script from "./grid.vue?vue&type=script&lang=js&"
export * from "./grid.vue?vue&type=script&lang=js&"
import style0 from "./grid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports